<template>
  <el-dialog title="修改密码" :visible.sync="dialogFormVisible"  append-to-body >
    <el-form :model="form" label-width="80px" :rules="rules" ref="formModel">
      <el-form-item label="密码" prop="pass">
        <el-input type="password" v-model="form.pass" autocomplete="off" show-password></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="checkPass">
        <el-input type="password" v-model="form.checkPass" autocomplete="off" show-password></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="save" :loading="btnLoading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>


import {post} from "@/utils/request";

export default {
  name: "resetPwd",
  components: {

  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      }else if (value.length < 6){
        callback(new Error('密码长度不能小于6位'));
      } else {
        if (this.form.checkPass !== '') {
          this.$nextTick(() => {
            this.$refs.formModel.validateField('checkPass');

          });
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.pass) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      dialogFormVisible:false,
      btnLoading:false,
      form:{
        dealerId:'',
        pass:'',
        checkPass:''
      },
      rules: {
        pass: [
          { required: true, validator: validatePass, trigger: 'blur' },
        ],
        checkPass: [
          { required: true, validator: validatePass2, trigger: 'blur' },
        ],
      }
    };
  },
  created() {

  },
  mounted() {

  },
  methods: {
    openDialog(data){
      this.form.dealerId = data.id
      this.form.pass = ''
      this.form.checkPass = ''
      this.dialogFormVisible = true
    },
    save() {
      this.btnLoading = true
      this.$refs['formModel'].validate((valid) => {
        if (valid) {
          //修改密码
          post('/dealer/resetPwd',this.form).then(res=>{
            this.$message({
              message: '修改成功',
              type: 'success'
            });
            this.btnLoading = false
            this.dialogFormVisible = false
          }).catch(err=>{
            this.btnLoading = false
          })
        } else {
          this.btnLoading = false
          return false;
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.name_status {
  display: inline-block;
  width: 26px;
  height: 17px;
  line-height: 15px;
  background: rgba(63, 114, 246, 0.11);
  border: 1px solid #3F72F6;
  border-radius: 4px;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #3F72F6;
  text-align: center;
}

.name_status1 {
  display: inline-block;
  width: 26px;
  height: 17px;
  line-height: 15px;
  background: rgba(243, 136, 46, 0.11);
  border: 1px solid #F3882E;
  border-radius: 4px;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #F3882E;
  text-align: center;
}

.copyTxt {
  display: inline-block;
  margin-left: 5px;
  cursor: pointer;
  color: #3F72F6;
}

.greenTag {
  color: #fff;
  background: #08A89B;
  border-radius: 6px;
  padding: 3px 5px;
  overflow: hidden;

}

.greyTag {
  background: #e5e5e5;
  color: #333;
  border-radius: 6px;
  padding: 3px 5px;
  overflow: hidden;

}

.redTag {
  background: #e5e5e5;
  color: #f00;
  border-radius: 6px;
  padding: 3px 5px;
  overflow: hidden;
}

.redBtn, .redColor {
  color: #f00;
}
</style>

